export const DOMAIN_URL = 'https://app.singularly.com'
